"use client";

import { PageHero } from "@/components/sections/page-hero";
import { CssStarfield } from "@/components/sections/css-starfield";
import { AboutHeroIllustration } from "@/components/illustrations/about-hero";

export function AboutHero() {
  return (
    <div className="relative overflow-hidden">
      <CssStarfield seed={7} className="absolute inset-0 -z-10" />
      <PageHero
        id="about-heading"
        eyebrow="About"
        lines={["Engineering", "as craft."]}
        description="Exec9 is a full-cycle software development agency in Lahore, Pakistan. Ten years, 250+ projects, and one connected team that owns the whole stack — architecture through delivery."
        accentColor="#a374e8"
        seed={7}
        illustration={AboutHeroIllustration}
        illustrationLabel="Illustration of a team assembling a solution together"
        headlineVariant="word-flip"
      />
    </div>
  );
}
